/**
 * Public reviews of a listing: travellers' reviews only. The server already
 * filters them (GET /reviews/service/{id}); this keeps the page safe with an
 * older API too. Old reviews without `direction` are travellers' reviews.
 */
export const isTravellerReview = (r) => Boolean(r) && (!r.direction || r.direction === 'client_to_provider');
